
import { mapActions, mapGetters } from "vuex";
import { MENU_PUBLISHED } from "@/constants/MixpanelEvents.js";
export default {
  data() {
    return {
      loading: false,
      isDelayed: false
    };
  },
  computed: {
    ...mapGetters("menu", ["isCatalogueSyncPending"]),

    isDisabled() {
      return !this.isCatalogueSyncPending || this.isDelayed;
    }
  },
  beforeDestroy() {
    this.$emit("stop-delay");
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getAddons",
      "catalogueSync",
      "getSyncStatus",
      "getCombosList"
    ]),
    async handleSync() {
      this.loading = true;
      try {
        if (this.isCatalogueSyncPending) await this.handleCatalogueSync();
        this.loading = false;
        this.$emit("start-delay");
        this.isDelayed = true;
        await this.sleep(20000);
        await this.getSyncStatus();
        await Promise.all([
          this.getMenuList(true),
          this.getAddons({ forceFetch: true }),
          this.getCombosList(true)
        ]);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.isDelayed = false;
      this.$emit("stop-delay");
    },

    async handleCatalogueSync() {
      try {
        await this.catalogueSync();
        this.mixPanelTrackEvent(MENU_PUBLISHED);
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", error);
      }
    }
  }
};
